<template>
    <div
        ref="rekisterointiModalContent"
        role="dialog"
        aria-modal="true"
        aria-labelledby="id-modalHeadingRekisterointitoimipaikat"
        @keydown.tab="trapFocus"
    >
        <header class="modal-header">
            <h1
                id="id-modalHeadingRekisterointitoimipaikat"
                ref="modalHeadingRekisterointitoimipaikat"
                tabindex="0"
                @keydown.tab="handleHeadingTab"
            >
                {{ header }}
            </h1>
            <button
                ref="modalButtonRekisterointitoimipaikat"
                type="button"
                class="btn-close"
                :aria-label="closeModalAriaLabel"
                @click="close"
                @keydown.esc="close"
            />
        </header>
        <section class="modal-body modal-font">
            <p class="modal-item-info">
                {{ $t("App.VesiLiikenne.Määrä") }}: <span>{{ count }}</span>
            </p>
            <!-- eslint-disable vue/no-v-html -->
            <span v-html="textContent" />
            <!--eslint-enable-->
        </section>
    </div>
</template>

<script lang="ts">
    import DynamicModalData from "@/models/dynamicmodaldata"
    import { Component, Vue, Prop } from "vue-facing-decorator"

    @Component
    export default class RekisterointitoimipaikatModal extends Vue {
        @Prop({ type: Boolean, default: false }) componentNameIsSet!: boolean

        mounted(): void {
            if (this.componentNameIsSet === true) {
                this.$nextTick(() => {
                    (this.$refs.modalHeadingRekisterointitoimipaikat as HTMLHeadingElement).focus()
                })
            }
        }

        close(): void {
            this.$store.dispatch("setModalComponentName", "")
        }

        get data(): DynamicModalData | null {
            return this.$store?.getters.modalData ?? null
        }

        get textContent(): string | null {
            return this.data?.textContent ?? ""
        }

        get header(): string | null {
            return this.data?.header ?? ""
        }

        get count(): string | null {
            return this.data?.count?.toString() ?? "0"
        }

        get closeModalAriaLabel(): string | undefined {
            return this.$t("App.Close")
        }

        trapFocus(event: KeyboardEvent) {
            const focusableElementsString = "a[href], button:not([disabled])"
            let focusableElements: HTMLElement[] = []

            if (this.$refs.rekisterointiModalContent instanceof HTMLElement) {
                focusableElements = Array.from((this.$refs.rekisterointiModalContent as Element).querySelectorAll<HTMLElement>(focusableElementsString))
            }

            const firstTabStop = focusableElements[0]
            const lastTabStop = focusableElements[focusableElements.length - 1]

            // Tarkistetaan, mikä event ja mikä modaalin elementti kyseessä ja siirrytään sen mukaan
            if (event.key === "Tab" || event.keyCode === 9) {
                if (event.shiftKey) /* shift + tab */ {
                    if (document.activeElement === firstTabStop) {
                        event.preventDefault()
                        lastTabStop?.focus()
                    }
                    else {
                        const index = focusableElements.indexOf(document.activeElement as HTMLElement)
                        const element = focusableElements[index - 1] as HTMLElement
                        element.focus()
                        event.preventDefault()
                    }
                }
                else /* tab */ {
                    if (document.activeElement === lastTabStop) {
                        event.preventDefault()
                        firstTabStop?.focus()
                    }
                    else {
                        const index = focusableElements.indexOf(document.activeElement as HTMLElement)
                        const element = focusableElements[index + 1] as HTMLElement
                        element.focus()
                        event.preventDefault()
                    }
                }
            }
        }

        handleHeadingTab(event: KeyboardEvent): void {
            if (event.shiftKey) /* shift + tab */ {
                (this.$refs.modalButtonRekisterointitoimipaikat as HTMLButtonElement).focus()
                event.preventDefault()
            }
        }
    }
</script>
